





































































































import Vue from 'vue'
import PicklItem from '@/components/common/PicklItem.vue'
import HollowCard from '@/components/common/HollowCard.vue'
import PicklDetailsPopup from '@/components/common/PicklDetailsPopup.vue'
import BulkDeletePicklPopup from '@/components/SAdmin/BulkDeletePicklPopup.vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import AddressesListPopup from '@/components/SAdmin/AddressesListPopup.vue'
import PopPickl from '@/components/common/PopPickl.vue'
import RelaunchPickl from '@/components/common/RelaunchPickl.vue'
import ExportPickl from '@/components/common/ExportPickl.vue'

declare var $: any

@Component({
  components: {
    HollowCard,
    PicklItem,
    PicklDetailsPopup,
    BulkDeletePicklPopup,
    AddressesListPopup,
    PopPickl,
    ExportPickl,
    RelaunchPickl
  }
})
export default class Pickls extends Vue {
  public totalSum: number = 0
  public active = 0
  public stores:any = []
  public brands:any[] =[]
  public user:any = {}
  public activePickl = {}
  public statuses:any[] = []
  public pickls:any = []
  public limitPerPage: number = 100
  public rowsOffset: number = 0
  public brandId:any = ''
  public productId:any = ''
  public locationId = ''
  public startDate = ''
  public storeLocationId:any = ''
  public storeId: any = ''
  public loadingPickls = true
  public hasMorePickls = false
  public storeLimitPerPage:number = 1000
  public storeOffset:number = 0
  public storeLocationLimitPerPage:number = 1000
  public storeLocationOffset:number = 0
  public brandLimitPerPage:number = 1000
  public brandOffset:number = 0
  public storeName: string = ''
  public storeLocations:any[] =[]
  public state:string = ''
  public timer:any
  public products:any = []
  public states:any = []
  public stateId: string =''
  public countries:any = []
  public countryId:string = ''
  public selectedPicklId: number = 0
  public deletedPickls: any[] = []
  public userRole: any = 'staff'
  public userUrl:any = 'staff'
  public sort:any = 'expire_date_time-ASC'
  public launchType:any = ''
  public selectablePicklDiv: boolean = false
  public selectedPicklsList:any[] = []
  public selectAllPickls: boolean = false
  public selectType: String = 'pop'

  get popButtonName () {
    if (this.selectablePicklDiv === true) {
      return 'CANCEL SELECT'
    } else {
      return 'SELECT'
    }
  }

  mounted () {
    this.getUserPicklCount()
    this.getStores()
    this.getBrands()
    this.getCountries()
    // this.getStates()
    let userData = this.$store.state.userData
    this.userRole = userData.role
    if (this.userRole === 'super-admin') {
      this.userUrl = 'sadmin'
    } else {
      this.userUrl = 'staff'
    }
  }

  onSelectAll () {
    this.selectedPicklsList = []
    if (this.selectAllPickls) {
      this.pickls.forEach((pickl: any) => {
        this.selectedPicklsList.push(pickl.id)
      })
    }
  }

  togglePicklContentSelectable () {
    this.selectablePicklDiv = !this.selectablePicklDiv
    if (this.selectablePicklDiv === false) {
      this.selectedPicklsList = []
      this.selectAllPickls = false
    }
  }
  isSelectedPickl (picklId: any) {
    if (this.selectedPicklsList.includes(picklId)) {
      return true
    } else {
      return false
    }
  }
  getCountries () {
    this.$http.get('countries?service_enabled=true').then((response:any) => {
      this.countries = response.body.data
    })
  }

  getStatesByCountry () {
    this.updateList()
    if (this.countryId !== '') {
      this.$http.get('states?country_id=' + this.countryId).then((response: any) => {
        this.states = response.body.data
      })
    } else {
      this.states = []
    }
  }

  getUserPicklCount () {
    this.loadingPickls = true
    this.$http
      .get('pickls/status-count')
      .then((response:any) => {
        this.statuses = response.body.data
        this.loadingPickls = false
        let status = this.$route.query['status']
        if (status) {
          for (let i = 0; i < this.statuses.length; ++i) {
            if (this.statuses[i].status === status) {
              this.active = i
              break
            }
          }
        }
        this.getPickls()
      }, response => {
        this.loadingPickls = false
      })
  }
  getPickls () {
    this.loadingPickls = true
    let params = { 'limit': this.limitPerPage, 'offset': this.rowsOffset, 'status': this.statuses[this.active].status, 'storeLocationId': this.storeLocationId, 'storeId': this.storeId, 'brandId': this.brandId, countryId: this.countryId, 'stateId': this.stateId, 'sort': this.sort, 'startDate': this.startDate, 'productId': this.productId, 'launchType': this.launchType }
    this.$http
      .get('pickls', { params: params })
      .then((response: any) => {
        if (this.limitPerPage === params.limit && this.rowsOffset === params.offset && params.status === this.statuses[this.active].status && this.storeLocationId === params.storeLocationId && this.brandId === params.brandId && this.startDate === params.startDate && this.productId === params.productId) {
          this.rowsOffset += this.limitPerPage
          this.pickls.push(...response.body.data)
          this.totalSum = response.body.sum
          if (this.pickls.length === response.body.count) {
            this.hasMorePickls = false
          } else {
            this.hasMorePickls = true
          }
          this.loadingPickls = false
        }
      }, response => {
        this.loadingPickls = false
      })
    this.$router.push({ query: { status: this.statuses[this.active].status } })
  }
  getStores (clear: boolean = true): void {
    this.$store.dispatch('getStores', { limit: this.storeLimitPerPage, offset: this.storeOffset, sort: 'name-ASC' }).then((response: any) => {
      this.stores.push(...response.response.body.data)
      this.storeOffset += this.storeLimitPerPage
      if (this.storeOffset < response.response.body.count) {
        this.getStores()
      }
    })
  }

  getBrands (clear: boolean = true): void {
    this.$store.dispatch('getBrands', { limit: this.brandLimitPerPage, offset: this.brandOffset, sort: 'name' }).then((response: any) => {
      this.brands.push(...response.response.body.data)
      if (this.brands.length < response.response.body.count) {
        this.brandOffset += this.brandLimitPerPage
        this.getBrands()
      }
    })
  }

  popRequested () {
    this.selectedPicklsList = []
    this.selectablePicklDiv = false
    this.pickls = []
    this.rowsOffset = 0
    this.updateList()
    this.updatePicklsCount()
  }

  exportRequested () {
    console.log('export requested')
  }

  updatePicklsList (index:number) {
    this.selectablePicklDiv = false
    this.selectedPicklsList = []
    this.active = index
    if (this.active === 1 || this.active === 0) {
      this.sort = 'expire_date_time-ASC'
    } else if (this.active === 2) {
      this.sort = 'updated_at-ASC'
    } else if (this.active === 3) {
      this.sort = 'updated_at-DESC'
    } else {
      this.sort = 'updated_at-DESC'
    }
    this.updateList()
  }
  updateBrandId (brandId:number) {
    this.updateList()
    if (this.brandId !== '') {
      this.$http.get('brands/' + this.brandId + '/products').then((response: any) => {
        this.products = response.body.data
      })
    } else {
      this.products = []
    }
  }

  updateProductId (productId:number) {
    this.updateList()
  }
  updatestartDate () {
    this.updateList()
  }
  updateStoreLocationId (storeLocationId: any) {
    if (this.locationId === '') {
      this.storeLocationId = this.storeLocations.map(location => location.id).join(',')
    } else {
      this.storeLocationId = this.locationId
    }
    if (this.storeLocations.length > 0) {
      this.updateList()
    } else {
      this.clearList()
    }
  }
  updateStoreId (storeId: any) {
    this.storeId = storeId
    this.updateList()
  }

  clearList () {
    this.pickls = []
    this.rowsOffset = 0
    this.hasMorePickls = false
  }

  updateList () {
    this.clearList()
    this.getPickls()
  }
  updatePicklsCount () {
    this.pickls = []
    this.rowsOffset = 0
    this.hasMorePickls = false
    this.getUserPicklCount()
  }

  getStoreLocations (storeId:any, reset:boolean = true) {
    this.locationId = ''
    this.storeLocationId = ''
    if (storeId === '') {
      this.updateList()
      this.storeLocations = []

      return false
    }
    if (reset) {
      this.storeLocations = []
      this.storeLocationLimitPerPage = 1000
      this.storeLocationOffset = 0
    }
    let q = { sort: 'id-ASC', storeId: storeId, 'limit': this.storeLocationLimitPerPage, offset: this.storeLocationOffset }
    this.$http
      .get('store_locations', { params: q })
      .then((response: any) => {
        if (this.storeLocationLimitPerPage === q.limit && this.storeLocationOffset === q.offset) {
          this.storeLocationOffset += this.storeLocationLimitPerPage
          this.storeLocations.push(...response.body.data)
          if (this.storeLocationOffset < response.body.count) {
            this.getStoreLocations(storeId, false)
          } else {
            this.updateStoreLocationId(null)
          }
        }
      }
      )
  }
  resetListing () {
    this.stateId = ''
    this.locationId = ''
    this.storeLocationId = ''
    this.storeName = ''
    this.storeLocations = []
    this.brandId = ''
    this.startDate = ''
    this.productId = ''
    this.getPickls()
  }

  getPicklDetails (id:number) {
    this.selectedPicklId = id
  }

  updatePicklOffset (deletedPicklId: any) {
    this.deletedPickls.push(deletedPicklId)
    // let closePicklDetailsPopupButton: HTMLElement = this.$refs.closePicklDetailsPopupButton as HTMLElement
    // closePicklDetailsPopupButton.click()
    this.rowsOffset = this.rowsOffset - 1
  }

  checkDeletedPIckls (picklId: any) {
    return this.deletedPickls.includes(picklId)
  }

  pushToPicklDetailsPage (picklId: any, multipleResponses: any, mixCampaign: any) {
    if (this.selectablePicklDiv) {
      this.toggleSelectedPicklList(picklId)
    } else {
      if (multipleResponses === 1) {
        this.$router.push('/' + this.userUrl + '/pickl-responses/' + picklId)
      } else {
        this.$store.dispatch('getPicklDetails', { picklId: picklId }).then((response: any) => {
          this.activePickl = response.response.body
          // Open the modal using Bootstrap/jQuery
          this.$nextTick(() => {
            $('#pickl-details-popup').modal('show')
          })
        }).catch((error: any) => {
          console.error('Error fetching pickl details:', error)
          this.$notify({
            group: 'notifications',
            type: 'error',
            title: 'Error',
            text: 'Failed to load pickl details'
          })
        })
      }
    }
  }
  toggleSelectedPicklList (picklId: any) {
    if (this.selectedPicklsList.includes(picklId)) {
      this.selectedPicklsList.splice(this.selectedPicklsList.indexOf(picklId), 1)
    } else {
      this.selectedPicklsList.push(picklId)
    }
  }

  @Watch('stateId')
  onPropertyChanged (value: string, oldValue: string) {
    let context = this
    clearTimeout(this.timer)
    this.timer = setTimeout(function () {
      context.updateList()
    }, 500 || 0)
  }
}
